import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="10" height="8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.905 1.098a1 1 0 010 1.414L4.515 6.9a1 1 0 01-1.414 0L1.095 4.894A1 1 0 012.509 3.48l1.3 1.3L7.49 1.098a1 1 0 011.414 0z" fill="#07A" /></svg>;